<template>
  <div>
    <subscribe-form
      :namespace="namespace"
      :section-data="sectionData"
      @subscribed="subscribed"
    />

    <subscribed
      :subscribed-visible="subscribedVisible"
      :already-subsribed-visible="alreadySubscribedVisible"
      @close="closeModals"
      @resend="resend"
      @redirect="redirectToSuccess"
    />
  </div>
</template>
<script>
  import SubscribeForm from 'components/SnippetTemplate/Items/Form'
  import Subscribed from 'components/SnippetTemplate/Modals/Subscribed'

  export default {
    components: {
      SubscribeForm,
      Subscribed
    },
    props: {
      namespace: {
        type: String,
        required: true
      },
      sectionData: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        subscribedVisible: false,
        alreadySubscribedVisible: false
      }
    },
    methods: {
      subscribed (subscribeStatus) {
        this.closeModals()

        if (subscribeStatus === 'subscribed') {
          this.subscribedVisible = true
        }

        if (subscribeStatus === 'already') {
          this.alreadySubscribedVisible = true
        }
      },
      redirectToSuccess () {
        if (typeof this.sectionData.successUrl !== 'undefined') {
          window.location.href = this.sectionData.successUrl
        }
      },
      resend () {
        this.$store.dispatch(this.namespace + '/submitForm')
      },
      closeModals () {
        this.subscribedVisible = false
        this.alreadySubscribedVisible = false
      }
    }
  }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
  @import "~assets/styles/common.scss";

  .wrap {
    padding: 0 23px 38px 23px;

    @include bp-mf-tablet {
      padding: 0;
      display: flex;
      flex-direction: row;
      justify-content: center;
      max-width: $desktop-width;
    }

    ::v-deep {

      .left-side {

        @include bp-mf-tablet() {
          width: calc(50% + 10px);
          padding: 55px 26px;
          background: $grey-the-whitest;
        }

        @include bp-mf-desktop() {
          min-height: 528px;
          padding: 116px 57px 100px 120px;
        }

        .description {
          margin-bottom: 30px;

          h2 {
            font-size: em(32);
            line-height: 1.2;
            margin: 0 0 15px;
            font-weight: 400;

            @include bp-mf-desktop() {
              font-size: em(36);
              margin: 0 0 35px;
            }
          }

          ul {
            margin-top: 18px;

            li {
              margin-bottom: 15px;
              padding-left: 31px;
              list-style: none;
              position: relative;
              font-size: em(14);
              line-height: 1.35;

              @include bp-mf-tablet() {
                font-size: em(18);
                margin-bottom: 5px;
              }

              @include bp-mf-desktop() {
                margin-bottom: 20px;
              }

              &:before {
                content: $icon-checkmark;
                @include icon-font();
                position: absolute;
                left: 0;
                top: 5px;
                font-size: em(10);
                color: $green-base;
              }
            }
          }
        }
      }

      .form-wrap {
        background: $grey-the-whitest;

        @include bp-mf-tablet() {
          width: calc(50% - 10px);
          padding: 22px 38px 29px 36px;
        }

        form {
          width: 100%;
          margin: 25px auto 0;
          border: 1px solid $gray-darker-border;
          background-color: $grey-the-whitest;
          border-radius: 6px;
          padding: 24px 15px 39px;

          @include bp-mf-tablet() {
            padding: 22px 38px 29px 36px;
            background-color: #ffffff;
            margin: 0 auto;
          }

          @include bp-mf-desktop() {
            max-width: 386px;
            padding: 33px 48px 32px 53px;
          }

          .label-wrap {
            display: block;
            margin-bottom: 4px;
            overflow: hidden;
            width: 100%;
            height: auto;
            font-size: em(12);
            font-weight: 700;

            @include bp-mf-tablet {
              font-size: em(13);
            }

            @include bp-mf-desktop {
              font-size: em(14);
            }

            label {
              line-height: 18px;
            }
          }

          .btn-blue {
            color: #ffffff;

            @include bp-mf-tablet {
              width: 100%;
            }
          }

          .input-block {
            margin-bottom: 15px;

            @include bp-mf-tablet {
              margin-bottom: 12px;
            }

            @include bp-mf-desktop {
              margin-bottom: 23px;
            }

            &.terms-block {
              display: flex;
              flex-direction: row;
              justify-content: flex-start;

              .terms-description {
                margin: 0;
                font-size: em(12);

                @include bp-mf-tablet {
                  font-size: em(13);
                }

                @include bp-mf-desktop {
                  font-size: em(14);
                }

                p {
                  margin: 0;
                  padding: 0;
                }
              }
            }


            &.error {

              .radio-wrap {

                span {
                  border-color: $red-dark !important;
                }
              }

              .dropdown-field {
                border: 1px solid $red-dark;
              }
            }

            &.dob {

              .dropdown-fields {
                display: flex;
                flex-direction: row;
                justify-content: space-between;

                .dropdown-wrap {
                  width: 30%;
                }
              }
            }

            .dropdown-field {
              height: 40px;
              line-height: 40px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              border-radius: 4px;

              &:after {
                top: 16px;
              }
            }

            .check-wrap {
              margin: 0 0 20px;

              label {
                line-height: 20px;

                input[type="checkbox"] {

                  &:checked + span:before {
                    background: $blue-medium;
                    border-color: $blue-medium;
                    line-height: 20px;
                    color: #ffffff;
                  }
                }

                span:before {
                  position: relative;
                  margin-right: 13px;
                  width: 20px;
                  height: 20px;
                  border: 1px solid $formInputBorder;
                  background: #ffffff;
                  border-radius: 4px;
                }
              }
            }

            .radio-items {
              @include clearfix();

              .radio-wrap {
                position: relative;
                float: left;
                margin: 0;
                width: 50%;
                background-color: #ffffff;
                text-align: center;
                cursor: pointer;

                &:last-child span {
                  border-radius: 0 4px 4px 0;
                }

                &:first-child span {
                  border-radius: 4px 0 0 4px;
                }

                &:not(:last-child),
                &:not(:last-child) span {

                  &:after {
                    content: '';
                    position: absolute;
                    top: 0;
                    right: -1px;
                    width: 1px;
                    height: 100%;
                    background-color: $blue-medium;
                    opacity: 0;
                  }
                }

                &:not(:last-child) {

                  &:hover,
                  input[type="radio"]:checked + span {
                    position: relative;

                    &:after {
                      opacity: 1;
                    }
                  }
                }

                input[type="radio"] {
                  display: none;

                  &:checked + span {
                    background: $blue-white;
                    border-color: $blue-medium;

                    &:before {
                      display: none;
                    }
                  }
                }

                span {
                  display: block;
                  padding: 0 10px;
                  border: 1px solid $gray-border;
                  font-weight: 500;
                  line-height: 40px;
                  color: $blue-medium;

                  &:before {
                    display: none;
                  }

                  &:hover {
                    border-color: $blue-medium;
                  }
                }
              }
            }

            input:not(.dropdown-field) {
              border-radius: 5px;
              padding: 0 13px;
              width: 100%;
              height: 40px;
              line-height: 40px;
              border: 1px solid $gray-border;
              font-size: em(12);
              color: $grey-black-lighter;

              @include bp-mf-tablet {
                padding: 0 19px;
                font-size: em(14);
              }

              &:disabled {
                background-color: rgb(235, 235, 228);
              }
            }
          }
        }
      }

      .button-wrap {

        button {
          background: #cddd07;
          height: 40px;
          line-height: 40px;
          color: #272a02 !important;
        }
      }

      .form-errors {
        border-radius: 6px;
        position: relative;

        &:before {
          content: $icon-error-triangle;
          @include icon-font();
          position: absolute;
          top: calc(50% - 10px);
          left: 12px;
          font-size: em(20);
          color: #d72918;
          display: block;
        }

        li {
          margin-left: 25px;

          @include bp-mf-tablet {
            margin-left: 0;
          }
        }
      }
    }
  }
</style>
